<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		height="30"
		width="30"
		fill="none"
		viewBox="0 0 30 30"
		aria-hidden="true"
	>
		<path
			d="M26.25 18.75V23.75C26.25 24.413 25.9866 25.0489 25.5178 25.5178C25.0489 25.9866 24.413 26.25 23.75 26.25H6.25C5.58696 26.25 4.95107 25.9866 4.48223 25.5178C4.01339 25.0489 3.75 24.413 3.75 23.75V18.75"
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="2"
		/>
		<path
			d="M8.75 12.5L15 18.75L21.25 12.5"
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="2"
		/>
		<path
			d="M15 18.75V3.75"
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="2"
		/>
	</svg>
</template>

<script>
export default {
	name: 'DownloadIcon',
}
</script>
